import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['amount', 'total', 'submit'];
  static values = { original: Number };

  connect() {
    this.updateTotal();
  }

  updateTotal() {
    let total = 0;
    this.amountTargets.forEach((input) => {
      total += parseInt(input.value, 10) || 0;
    });

    this.totalTarget.textContent = total.toLocaleString();

    const isValid = total === this.originalValue && this.amountTargets.every((input) => parseInt(input.value, 10) > 0);
    this.submitTarget.disabled = !isValid;
  }
}
